import { useEffect } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { useGetHotKey } from './useGetHotKey';
export function useHotKey(hotKeyList, callback, eventType) {
  var cb = useRefCallback(callback);
  var hotkey = useGetHotKey();
  useEffect(function () {
    var hotKeys = hotKeyList.split(',');
    hotkey.addHotKeys(hotKeys, cb, eventType);
    return function () {
      hotkey.removeHotKeys(hotKeys, cb, eventType);
    };
  }, [hotKeyList, eventType]);
}